// extracted by mini-css-extract-plugin
export default {"wrap":"nH-z","fullWidth":"oH-z","hideOnDesktop":"pH-z","content":"qH-z","hasOpenedNav":"rH-z","crumbsList":"sH-z","dropdownsWrap":"tH-z"};